var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 5.33356H0V26.6664H32V5.33356Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 5.33356H0V12.4445H32V5.33356Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 19.5555H0V26.6664H32V19.5555Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7826 12.7537H16.9275L17.2367 10.4348L18.4734 9.50725L19.7101 10.4348V12.2899L18.7826 12.7537Z",
    fill: "#338AF3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2174 12.7537H15.0725L14.7633 10.4348L13.5266 9.50725L12.2899 10.4348V12.2899L13.2174 12.7537Z",
    fill: "#338AF3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2367 12.7537H14.7632V10.4348L15.9999 9.50725L17.2367 10.4348V12.7537Z",
    fill: "#0052B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2899 12.2899V17.3913C12.2899 18.6061 12.8767 19.6863 13.7817 20.3635L14.4309 20.201L15.2502 21.0252C15.4925 21.0751 15.7432 21.1014 16 21.1014C16.2554 21.1014 16.5048 21.0755 16.7459 21.0261L17.6811 20.2474L18.2183 20.3621C19.1229 19.6849 19.71 18.6057 19.71 17.3914V12.2899L12.2899 12.2899Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7741 12.2901H12.29V13.7741H13.7741V12.2901Z",
    fill: "#D80027"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7418 12.2901H15.2577V13.7741H16.7418V12.2901Z",
    fill: "#D80027"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7101 12.2901H18.2261V13.7741H19.7101V12.2901Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.258 13.7739H13.7739V15.258H15.258V13.7739Z",
    fill: "#D80027"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2262 13.7739H16.7422V15.258H18.2262V13.7739Z",
    fill: "#D80027"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7741 15.2577H12.29V16.7418H13.7741V15.2577Z",
    fill: "#D80027"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.258 16.7416H13.7739V18.2256H15.258V16.7416Z",
    fill: "#D80027"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7418 15.2577H15.2577V16.7418H16.7418V15.2577Z",
    fill: "#D80027"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7101 15.2577H18.2261V16.7418H19.7101V15.2577Z",
    fill: "#D80027"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2262 16.7416H16.7422V18.2256H18.2262V16.7416Z",
    fill: "#D80027"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7418 18.2261H15.2577V19.7101H16.7418V18.2261Z",
    fill: "#D80027"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7739 18.2258H12.3856C12.513 18.7774 12.7632 19.2823 13.1066 19.7099H13.7739V18.2258Z",
    fill: "#D80027"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2261 19.7098H18.8934C19.2367 19.2822 19.487 18.7774 19.6144 18.2257H18.2261V19.7098Z",
    fill: "#D80027"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7739 19.7098V20.3574C14.2056 20.6821 14.7099 20.9151 15.258 21.0268V19.7098H13.7739V19.7098Z",
    fill: "#D80027"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7421 19.7098V21.0268C17.2901 20.9151 17.7945 20.6821 18.2261 20.3574V19.7098H16.7421V19.7098Z",
    fill: "#D80027"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/HR.3280efed.svg";
export { ForwardRef as ReactComponent };